export const version = '2.0.0-canary.fbf15e884633'
